// ✅ Add this fetchConfig globally at the top
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
}

// ✅ Replace your CartItems class's updateQuantity method with this:
class CartItems extends HTMLElement {
  constructor() {
    super();
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    const eventTarget =
      event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(routes.cart_change_url, {
      ...fetchConfig(),
      body
    })
      .then(response => response.json())
      .then(parsedState => {
        /* YOUR EXISTING LOGIC (UNCHANGED) */
      })
      .catch(err => {
        console.error('Cart update failed:', err);
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
}

customElements.define('cart-items', CartItems);




// ✅ Add this fetchConfig globally at the top
// function fetchConfig(type = 'json') {
//   return {
//     method: 'POST',
//     headers: {
//       'Accept': 'application/json',
//       'Content-Type': 'application/json'
//     }
//   };
// }

// // ✅ Replace your CartItems class's updateQuantity method with this:
// updateQuantity(line, quantity, event, name, variantId) {
//   this.enableLoading(line);

//   const body = JSON.stringify({
//     line,
//     quantity,
//     sections: this.getSectionsToRender().map((section) => section.section),
//     sections_url: window.location.pathname,
//   });

//   const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

//   fetch(`${routes.cart_change_url}`, {
//     ...fetchConfig(),
//     body
//   })
//     .then((response) => {
//       return response.json();
//     })
//     .then((parsedState) => {
//       const quantityElement =
//         document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
//       const items = document.querySelectorAll('.cart-item');

//       if (parsedState.errors) {
//         quantityElement.value = quantityElement.getAttribute('value');
//         this.updateLiveRegions(line, parsedState.errors);
//         return;
//       }

//       this.classList.toggle('is-empty', parsedState.item_count === 0);
//       const cartDrawerWrapper = document.querySelector('cart-drawer');
//       const cartFooter = document.getElementById('main-cart-footer');

//       if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
//       if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

//       this.getSectionsToRender().forEach((section) => {
//         const elementToReplace =
//           document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//         const newHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
//         if (elementToReplace && newHTML) {
//           elementToReplace.innerHTML = newHTML;
//         }
//       });

//       const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
//       let message = '';
//       if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
//         if (typeof updatedValue === 'undefined') {
//           message = window.cartStrings.error;
//         } else {
//           message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
//         }
//       }
//       this.updateLiveRegions(line, message);

//       const lineItem =
//         document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
//       if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
//         cartDrawerWrapper
//           ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
//           : lineItem.querySelector(`[name="${name}"]`).focus();
//       } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
//         trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
//       } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
//         trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
//       }

//       publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
//     })
//     .catch((err) => {
//       console.error('Cart update failed:', err);
//       this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
//       const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
//       errors.textContent = window.cartStrings.error;
//     })
//     .finally(() => {
//       this.disableLoading(line);
//     });
// }
